module.exports = __webpack_public_path__ + "images/astonmartin_smallcf1adbd1503d841cd8349f369adc245f.png";